'use strict';

var $ = require('jquery');
var hoverintent = require('hoverintent');

var mobileHoverintent = function (element, touchCallback, onCallback, offCallback) {
    $(element).on('touchend', touchCallback);
    return hoverintent(element, onCallback, offCallback);
};

module.exports = mobileHoverintent;
